import React from 'react'

import { ShortcutTooltip } from 'components/ui/ShortcutTooltip'
import { useCatalogYogiQLFilterSidebar } from 'features/catalog/hooks/use-catalog-yogiql-filter-sidebar'
// bully ignore[no-cross-feature-private-imports: the same shared ControlsSidebar shell CatalogFilterSidebar mounts; this is its enhanced_dialect twin. follow-up: .agents/follow-ups/bully-typescript-cross-feature-hooks.md]
import { ControlsSidebar } from 'features/charts-v2/components/ControlsSidebar/ControlsSidebar'
import type { FeedbackQueryCodec } from 'features/feedback/feedback-query'
import { GLOBAL_SHORTCUT_KEYS } from 'hooks/keyboard-shortcuts'
import { useShortcutDisplay } from 'hooks/use-keyboard-shortcuts'

type Props = {
  isCollapsed: boolean
  onToggleCollapse: () => void
  /** The catalog and filter options edits encode against; null while loading. */
  codec: FeedbackQueryCodec | null
}

/** `CatalogFilterSidebar` under `enhanced_dialect`: the same filter section,
 *  editing the panel's YogiQL query. Nothing shows until the codec loads. */
export const CatalogYogiqlFilterSidebar: React.FC<Props> = ({
  isCollapsed,
  onToggleCollapse,
  codec,
}) => {
  const shortcut = useShortcutDisplay(
    GLOBAL_SHORTCUT_KEYS.NESTED_SIDEBAR_TOGGLE,
  )
  const sidebar = useCatalogYogiQLFilterSidebar(codec)
  if (!sidebar) return null

  return (
    <ControlsSidebar
      sections={['filter']}
      header={{
        isCollapsed,
        onToggleCollapse,
        title: 'Filter',
        collapseTooltip: (
          <ShortcutTooltip label="Hide filters" shortcut={shortcut} />
        ),
        expandTooltip: (
          <ShortcutTooltip label="Show filters" shortcut={shortcut} />
        ),
      }}
      filter={sidebar}
    />
  )
}
